import script from "./LockAmount.vue?vue&type=script&setup=true&lang=ts"
export * from "./LockAmount.vue?vue&type=script&setup=true&lang=ts"

import "./LockAmount.vue?vue&type=style&index=0&id=f4ddaf14&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4ddaf14"]])

export default __exports__